export const federicoVargas = {
  testimonial:
    'Mi mayor satisfacción como entrenador de la Asociación Iberoamericana de Scrum es poder ayudar a personas de toda la región a través de los entrenamientos que imparto. Comparto el propósito de AIBES de entregar entrenamientos de calidad, con una formación responsable, enseñando desde mi experiencia e influyendo positivamente en el desempeño profesional de las personas con las que interactúo. Creo en la posibilidad de cambiar el Mundo por medio de la formación de mejores individuos y como entrenador de AIBES puedo servir a este propósito.',
  trainer: 'Federico Vargas',
  trainerProfile: '/entrenadores/federico-vargas/',
  trainerPicture: '/images/entrenadores/federico-vargas.jpg',
  position: 'CEO de',
  company: 'Grupo Empresarial 360',
  companyUrl: '/socios/grupo-empresarial-360/',
};

export const erickMasgo = {
  testimonial:
    'El éxito de las formaciones a nuestro cargo no sólo se basa en la certificación, sino en el compromiso de los que formamos parte de la AIBES para entregar contenido de valor y con la responsabilidad que significa la aplicación de estos conocimientos en las diferentes organizaciones. AIBES se consolida como una certificadora responsable en la formación de profesionales hispanohablantes, para mí es un gusto formar parte de esta prestigiosa organización y colaborar en sus procesos formativos en la entrega de contenidos de valor desde una visión práctica.',
  trainer: 'Erick Masgo',
  trainerProfile: '/entrenadores/erick-masgo/',
  trainerPicture: '/images/entrenadores/erick-masgo.jpg',
  position: 'Gerente General en',
  company: 'F&M Consulting',
  companyUrl: '/socios/fm-consulting/',
};
